export default __webpack_public_path__ + "static/media/brand-12.6bc8f7a5.png";